








































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { SuketPulangInterface } from "@/types/suket_pulang";
// import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketPulang from "@/services/SuketPulang";
import StoreSuketPulang from "@/store/modules/SuketPulang";
import moment from "moment";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import { storeUnit } from "@/store/modules/unit";
// import { storeResepFarmasi } from "@/store/modules/resepfarmasi";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class InputSuketPulangCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() value!: SuketPulangInterface;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  register_id = this.value?.register_id || this.register;
  pasien_rm = this.value?.pasien_rm || this.statePasien.rm;

  nama = this.statePasien.nama;
  tgl_lahir = this.statePasien.tgl_lahir;
  umur = this.statePasien.usia;
  alamat = this.statePasien.alamat;

  diagnosis = this.value?.content.diagnosis || "";
  pengobatan = this.value?.content.pengobatan || "";
  anjuran = this.value?.content.anjuran || "";
  tgl_kontrol = this.value?.content.tgl_kontrol || null;
  tujuan_kontrol = this.value?.content.tujuan_kontrol || null;
  // via = this.value?.content.via || null;
  note = this.value?.content.note || null;

  unit_id = this.value?.unit_id || this.user.unit_id;
  surat_date = this.value?.surat_date || moment().format("YYYY-MM-DD");
  signee_user_id = this.value?.signee_user_id || this.user.id;
  creator_user_id = this.value?.creator_user_id || this.user.id;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  saving = false;
  tglKontrolShow = false;
  minDate = moment().format("YYYY-MM-DD");
  maxSuratDate = moment().format("YYYY-MM-DD");
  showSuratDatePicker = false;

  // get viaPkm() {
  //   return this.via !== null ? true : false;
  // }
  // set viaPkm(val) {
  //   if (val) {
  //     this.via = {
  //       id: 1,
  //       name: "Puskesmas/ PPK1"
  //     };
  //   } else {
  //     this.via = null;
  //   }
  // }

  get statePasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      unit_id: this.unit_id,
      pasien_rm: this.pasien_rm,
      content: {
        diagnosis: this.diagnosis,
        pengobatan: this.pengobatan,
        anjuran: this.anjuran,
        tgl_kontrol: this.tgl_kontrol,
        tujuan_kontrol: this.tujuan_kontrol,
        // via: this.via
        note: this.note
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get asesmenGadarMedis() {
    return AsesmenGadarMedisStore.asesmen;
  }

  get tglKontrolFormated() {
    return this.tgl_kontrol
      ? moment(this.tgl_kontrol, "YYYY-MM-DD").format("DD MMMM YYYY")
      : null;
  }

  get suratDateFormated() {
    return this.surat_date
      ? moment(this.surat_date, "YYYY-MM-DD").format("DD MMMM YYYY")
      : null;
  }

  mounted() {
    if (!this.value) {
      if (!this.diagnosis) {
        this.diagnosis = this.asesmenGadarMedis?.content.diagnosis.kerja;
      }

      if (!this.tgl_kontrol) {
        this.tgl_kontrol = this.asesmenGadarMedis?.content.tindakLanjut
          .tglKontrol
          ? new Date(this.asesmenGadarMedis?.content.tindakLanjut.tglKontrol)
          : null;
      }

      if (!this.tujuan_kontrol) {
        const unit = storeUnit.unitPagi.find(
          item =>
            this.asesmenGadarMedis?.content.tindakLanjut.unitKontrol == item.id
        );
        this.tujuan_kontrol = unit?.nama ?? null;
      }
    }
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      const action = this.value
        ? SuketPulang.update(this.value.id, this.input)
        : SuketPulang.create(this.input);

      action
        .then(() => {
          this.$emit("showSignatureModal");

          appModule.NoticeDelay("Berhasil Simpan Surat Keterangan Mata");

          this.close();
          StoreSuketPulang.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }

  tglFormat() {
    return this.tgl_kontrol
      ? moment(this.tgl_kontrol, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }
}
